import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-doc-summary',
  templateUrl: './doc-summary.component.html',
  standalone: false
})
export class DocSummaryComponent {
  @Input() currency: string = ' ';

  @Input() amount: number = 0;

  @Input() outstanding: number = 0;

  @Input() cancelled: boolean = false;

  @Input() bounced: boolean = false;

  @Input() pdc: boolean = false;

  @Input() showOutstanding: boolean = true;

  @Input() protected: boolean = false;

  constructor() {}
}
